import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53c11066"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "about u-dark" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"about__inner u-inner u-grid\" data-v-53c11066><h3 data-animation=\"fadeUp\" data-v-53c11066> The voices </h3><div class=\"about__intro\" data-v-53c11066><div class=\"about__desc\" data-animation=\"fadeUp\" data-v-53c11066><div class=\"u-text-large\" data-v-53c11066><p data-v-53c11066> The financial services sector is going through transformative change. To predict what the future of the sector could look like, we interviewed leaders from across financial services and beyond – insiders, outsiders and challengers – asked them to place themselves in 2030 and describe the financial landscape they think could emerge in the years ahead. </p></div></div><div class=\"about__desc\" data-animation=\"fadeUp\" data-v-53c11066><div data-v-53c11066><p data-v-53c11066>The ’Voices’ in this report cover many facets of financial services and beyond — from incumbents to challengers, BigTech to fintechs, policy makers to legal experts. Taken together, they create a valuable chorus of insight and expertise.</p><p data-v-53c11066>A summary of their insights can be found below. </p><p data-v-53c11066>Many of the views expressed in this report may be aspirational and personal and may not necessarily represent those of the Voices’ organizations or that of KPMG.</p></div></div></div></div>", 1)
const _hoisted_4 = { class: "contact u-dark" }
const _hoisted_5 = { class: "contact__inner u-grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact__header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/logo.png",
    alt: "KPMG",
    class: "contact__logo"
  })
], -1))
const _hoisted_7 = { class: "contact__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { "data-animation": "fadeUp" }, "Contacts", -1))
const _hoisted_9 = { class: "contact__list" }
const _hoisted_10 = ["data-delay"]
const _hoisted_11 = {
  class: "contact__item",
  "data-cursor": "small"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "contact-avatar" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "contact__info" }
const _hoisted_16 = { class: "contact__name" }
const _hoisted_17 = { class: "contact__position" }
const _hoisted_18 = { class: "copyright u-inner u-dark" }
const _hoisted_19 = { class: "overlay" }


const __default__ = {
  name: 'HomePage',
  mixins: [mixin],
};

import {
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';

import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { gsap } from 'gsap';
import { State } from '@/store';
import mixin from '@/mixins/global';
import HeaderComponent from '@/layouts/Header.vue';
import ButtonComponent from '@/components/Button.vue';
import ButtonIcon from '@/components/ButtonIcon.vue';
import ChapterSections from '@/components/Chapter/index.vue';
import PeopleComponent from '@/components/People.vue';
import SVGArrowDown from '@/svgs/arrow-down.svg';
import chapters from '@/chapters';
import contacts from '@/contacts';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const year = new Date().getFullYear();
const router = useRouter();
const store = useStore<State>();
const arrowRef = ref<InstanceType<typeof ButtonComponent>>();
const imageRef = ref<HTMLElement>();
const wrapperRef = ref<HTMLElement>();
const isLoading = ref(false);
const isAnimated = ref(false);
const doc = document.documentElement;
const mobileWidth = 576;
const isMobile = window.innerWidth <= mobileWidth;

const onScroll = () => {
  if (!arrowRef.value || isAnimated.value) return;
  const st = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

  if (st > 0) {
    gsap.killTweensOf(arrowRef.value.$el);
    gsap.to(arrowRef.value.$el, { opacity: 0, duration: 0.5 });
    isAnimated.value = true;
    window.removeEventListener('scroll', onScroll);
  }
};

const onTransition = async (element: HTMLElement) => {
  if (!imageRef.value || !element || !wrapperRef.value) return Promise.resolve();
  const parent = element.parentElement;
  const target = parent?.querySelector('img');
  if (!target) return Promise.resolve();
  const padding = window.innerWidth * 0.031;
  const gutterSpace = window.innerWidth * 0.01666;
  const offest = element.getBoundingClientRect();
  const image = document.createElement('img');
  const rem = window.innerWidth * 0.0104;

  image.src = target.src;
  imageRef.value.style.top = `${offest.top}px`;
  imageRef.value.style.left = isMobile ? `${padding}px` : `${offest.left}px`;
  imageRef.value.appendChild(image);
  image.style.width = `${target.clientWidth}px`;
  image.style.height = `${target.clientHeight}px`;
  gsap.set(imageRef.value, { opacity: 1 });
  isLoading.value = true;

  await gsap.to(wrapperRef.value, { opacity: 0 });

  if (!isMobile) {
    gsap.to(image, {
      width: window.innerWidth / 2 - padding - gutterSpace / 2,
    });
  }

  return gsap.to(imageRef.value, {
    top: isMobile ? 84 : window.innerWidth * 0.03 + (rem * 3.6),
    left: padding,
    opacity: 1,
  });
};

const onNavigationClick = async(event: Event, id: string | number) => {
  event.preventDefault();
  await onTransition(event.currentTarget as HTMLElement);

  setTimeout(() => {
    router.push(`/person/${id}`);
    isLoading.value = false;
  }, 750);
};

// const handleHeroScrollerClick = () => {
//   gsap.to(document.documentElement, { scrollTo: window.innerHeight });
// };

// const handleHeroPersonClick = (event: Event, slug = 'joe-blogs') => {
//   const { posts } = store.state.posts;
//   if (!posts) return;
//   const person = posts.find(post => post.slug === slug);
//   store.dispatch('setPost', person);
//   onNavigationClick(event, slug);
// };

onMounted(() => {
  window.addEventListener('scroll', onScroll);

  if (arrowRef.value) {
    gsap.to(arrowRef.value.$el, { opacity: 1, delay: 1.2 });
  }

  if (store.state.status.currentChapter) {
    const index = store.state.status.currentChapter;
    store.dispatch('setCurrentChapter', undefined);
    const chapterElement = document.querySelector(`[data-chapter="${index}"]`);

    if (chapterElement) {
      const offset = chapterElement.getBoundingClientRect();
      const top = offset.top + window.scrollY;
      gsap.to(document.documentElement, { scrollTo: top });
    }
  }

  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      console.log('ready');
      // run code here
      if (store.state.widgets.scroll) {
        store.state.widgets.scroll.init();
      }
    }
  };
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", {
      class: "home",
      ref_key: "wrapperRef",
      ref: wrapperRef
    }, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createVNode(PeopleComponent)
      ]),
      (_unref(chapters) && _ctx.$store.state.posts.posts)
        ? (_openBlock(), _createBlock(ChapterSections, {
            key: 0,
            transition: onNavigationClick
          }))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contacts), (contact, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: contact.name,
                  "data-animation": "fadeUp",
                  "data-delay": 0.1 * index
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (contact.link)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "contact__link",
                          href: contact.link,
                          target: "_top"
                        }, _toDisplayString(contact.name), 9, _hoisted_12))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: contact.image,
                        alt: `contact: ${contact.name}`,
                        class: "contact-avatar__image"
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(contact.name), 1),
                      _createElementVNode("p", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(contact.role), 1),
                        _createTextVNode(", " + _toDisplayString(contact.company), 1)
                      ])
                    ])
                  ])
                ], 8, _hoisted_10))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("p", _hoisted_18, " © " + _toDisplayString(_unref(year)) + " Copyright owned by one or more of the KPMG International entities. KPMG International entities provide no services to clients. All rights reserved. ", 1)
    ], 512),
    _createElementVNode("div", {
      class: "preview-image",
      ref_key: "imageRef",
      ref: imageRef
    }, null, 512),
    _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
      [_vShow, isLoading.value]
    ])
  ]))
}
}

})